// extracted by mini-css-extract-plugin
export var cards = "FixableCards-module--cards--d1ppY";